// Webpack Imports
import * as bootstrap from 'bootstrap'
import Search from './modules/Search'
var liveSearch = new Search()

;(function () {
  ;('use strict')

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      })
    })
  })

  const secondaryMenu = document.getElementById('secMenu')
  const secondaryBtn = document.getElementById('nav-icon1')
  const secondaryBtnTxt = document.getElementById('menuTxt')
  const body = document.getElementsByTagName('body')[0]

  secondaryMenu.addEventListener('click', function () {
    body.classList.toggle('stop-scrolling')
    secondaryMenu.classList.toggle('is-open')
    secondaryBtn.classList.toggle('open')

    if (secondaryBtn.classList.contains('open')) {
      secondaryBtnTxt.innerText = 'sluiten'
    } else {
      secondaryBtnTxt.innerText = 'menu'
    }

    //   overlay.style.display = 'block'
    // })
    // el.addEventListener('mouseout', function () {
    //   overlay.style.display = 'none'
  })

  // Close Icon Toolbar
  const stickyIconToolBar = document.getElementById('stickyIconToolBar')
  const closeBtn = document.querySelector('.close-btn')
  var hover = false

  // iconToolBar Mouseover
  stickyIconToolBar.addEventListener(
    'mouseover',
    function (event) {
      if (!hover) {
        closeBtn.style.top = '-1rem'
      }
      hover = true
    },
    false
  )

  // iconToolBar Mouseleave
  stickyIconToolBar.addEventListener(
    'mouseleave',
    function (event) {
      hover = false
      closeBtn.style.top = '0.1rem'
    },
    false
  )

  // Close button
  closeBtn.addEventListener('click', function (event) {
    stickyIconToolBar.classList.add('hide-toolbar')
    sessionStorage.setItem('toolbar', 'closed')
  })

  setTimeout(() => {
    stickyIconToolBar.classList.remove('hide-toolbar')
  }, 3000)

  if (!$('body.home').length) {
    // Resize Page Header Element
    var onResizing = function (event) {
      let pageHeaderTxt = document.getElementById('pageHeaderLeft')
      let pageHeaderImg = document.getElementById('pageHeaderRight')

      if (window.innerWidth > 768 && !$('body.page-template-page-contact').length) {
        let pageHeaderImgHeight = pageHeaderTxt.clientHeight + 160
        pageHeaderImg.style.height = pageHeaderImgHeight + 'px'
      } else if (window.innerWidth > 992 && $('body.page-template-page-contact').length) {
        let pageHeaderImgHeight = pageHeaderTxt.clientHeight + 160
        pageHeaderImg.style.height = pageHeaderImgHeight + 'px'
      } else {
        pageHeaderImg.style.height = '320px'
      }
    }
  }

  window.onresize = onResizing
  window.onload = onResizing
})()
